module.exports = __webpack_public_path__ + "static/media/george-goodall.04ec2ce4.jpg";